import clsx from 'clsx'
import React from 'react'
import Box from '@mui/material/Box'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import {makeStyles} from 'external/material'
import Fade from '@mui/material/Fade'
import {faEdit} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Editor from '../../jodit'
import Button from './button'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    "& .editor": {
      display: 'none',
      "&.ready": {
        display: 'flex',
        flexGrow: 1,
        "& .jodit-container": {
          flexGrow: 1,
          "& .jodit-wysiwyg": {
            "&:focus": {
              outline: '#3260c9 auto 1px'
            }
          }
        }
      }
    },
  },
}))

export default function EditableHtml (props) {

  const classes = useStyles()
  const {context, onChange} = props
  const config = props.config || {
    uploader: {
      insertImageAsBase64URI: true
    },
    showPlaceholder: true,
    enter: "BR",
    disablePlugins: "wraptextnodes",
    toolbarAdaptive: false,
    showXPathInStatusbar: true,
    language: context.languageId,
    toolbarButtonSize: "small",
    buttons: "bold,strikethrough,underline,italic,|,symbol,superscript,subscript,image,|,ul,ol,|,outdent,indent,|,font,fontsize,brush,paragraph,|,,align,undo,redo,fullsize"
  }

  const [jodit, setJodit] = React.useState(undefined)
  const [ready, setReady] = React.useState(false)
  const parser = new DOMParser()
  function handleChange (html) {
    const doc = parser.parseFromString(html, "text/html")
    const treeWalker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT)
    const nodeList = []
    let currentNode =  treeWalker.nextNode()
    while(currentNode) {
      nodeList.push(currentNode.textContent)
      currentNode = treeWalker.nextNode()
    }
    onChange && onChange(html, nodeList.join(' '))
  }

  function handleInit(jodit) {
    setJodit(jodit)
  }

  React.useLayoutEffect(() => {
    setReady(true)
  }, [])

  React.useEffect(() => {
    if (jodit)
      jodit.setElementValue(props.html)
  }, [props.html])

  return (
    // <Fade in={ready} timeout={500}>
      <Box className={clsx(classes.root, "html-editor-root")}>
          <Box className={clsx("editor", {ready})} >
            <Editor
              value={props.html}
              config={config}
              onInit={handleInit}
              onBlur={handleChange}
              onChange={newContent => {}}
              />
          </Box>
      </Box>
    // </Fade>

  )
}
